export const signUpInitialValues = {
  firstName: '',
  lastName: '',
  email: '',
  phoneMask: '',
  location: '',
};
